import { render, staticRenderFns } from "./tbBuy.vue?vue&type=template&id=f2925e86&scoped=true&"
import script from "./tbBuy.vue?vue&type=script&lang=js&"
export * from "./tbBuy.vue?vue&type=script&lang=js&"
import style0 from "./tbBuy.vue?vue&type=style&index=0&id=f2925e86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2925e86",
  null
  
)

export default component.exports